import { getReducerErrorMessage } from 'src/utils/helpers'

const initialState = {
  isGetCustomContentInProgress: false,
  getCustomContentResponse: {},
}

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case 'GET_CUSTOM_CONTENT': {
      return {
        ...state,
        isGetCustomContentInProgress: true,
        getCustomContentResponse: {},
      }
    }
    case 'GET_CUSTOM_CONTENT_COMMIT': {
      return {
        ...state,
        isGetCustomContentInProgress: false,
        getCustomContentResponse: {
          success: true,
          // Actual content should be here
          payload: action.payload,
        },
      }
    }
    case 'GET_CUSTOM_CONTENT_ROLLBACK': {
      return {
        ...state,
        isGetCustomContentInProgress: false,
        getCustomContentResponse: {
          success: false,
          message: getReducerErrorMessage(action),
        },
      }
    }

    default: {
      return state
    }
  }
}
